import Auth from "./shared/Auth";
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router(
{
	mode: "history",

	base: process.env.BASE_URL,

	routes: [
		{
			path: "/",
			name: "index",
			component: () => import("./views/Index.vue"),
			meta: {
				requiresAuth: true
			}
		},

		{
			path: "/ks",
			name: "kitchen-sink",
			component: () => import("./views/KitchenSink.vue")
		},

		{
			path: "/all",
			name: "all",
			component: () => import("./views/All.vue"),
			meta: {
				requiresAuth: true
			}
		},

		{
			path: "/list",
			name: "list",
			component: () => import("./views/List.vue"),
			meta: {
				requiresAuth: true
			}
		},

		{
			path: "/item/?id",
			name: "item",
			component: () => import("./views/Item.vue"),
			meta: {
				requiresAuth: true
			}
		},

		{
			path: "/sign-in",
			name: "sign-in",
			component: () => import("./views/SignIn.vue")
		},

		{
			path: "/sign-out",
			name: "sign-out",
			component: () => import("./views/SignOut.vue")
		}
	]
});

router.beforeEach((to, from, next) =>
{
	if (to.matched.some(record => record.meta.requiresAuth))
	{
		const currentUser = new Auth().getCurrentUserSync();

		if (currentUser === null)
		{
			next({ path: "/sign-in" });
		}
		else
		{
			next();
		}
	}
	else
	{
		next();
	}
});

export default router;
